import { render, staticRenderFns } from "./upd.vue?vue&type=template&id=bebcbcc0&scoped=true&"
import script from "./upd.vue?vue&type=script&lang=js&"
export * from "./upd.vue?vue&type=script&lang=js&"
import style0 from "./upd.vue?vue&type=style&index=0&id=bebcbcc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebcbcc0",
  null
  
)

export default component.exports